function CancellationandRefund() {
  return (
    <section id=" " className="bg-light">
      <div
        className="container pt-5 text-dark pb-md-5"
        style={{ maxWidth: "1000px" }}
      > 
        <h2 className="color-blue text-center">
          <strong>Cancellation & Refund Policy</strong>
        </h2>

        <p className="lh-lg">  
            At Vyomscode, we strive to deliver high-quality digital solutions tailored to each client’s 
            unique needs. As we provide custom software and service-based offerings (including website 
            development, mobile apps, design, and more), our processes begin immediately after project 
            confirmation. Please read our policy carefully before committing to any service.

          <br />
          <br /> <h5 className="mb-0"> 1. Project Initiation & Advance Payment</h5>
            Once a project is confirmed and the advance payment is made, the project is considered to be 
            in progress. This advance payment serves as a confirmation of service engagement and covers 
            initial resource allocation, research, planning, and partial development work.  <br />
            ❌ Therefore, no cancellation or refund is allowed after the advance payment is made and the project has begun.
          <br />
          <br /> <h5 className="mb-0"> 2. Service-Based Work – No Reversal</h5>
            As our services are customized and time-bound, once the service has started:
          <br />
            The process cannot be paused or reversed.
          <br />
            Our team invests time, resources, and expertise from day one.
          <br />
            Thus, refunding the paid amount is not feasible under service-based project structures.
          <br />
          <br /> <h5 className="mb-0"> 3. Voluntary Cancellation by Client</h5>
            If the client still chooses to cancel the project midway, the following conditions apply:
          <br />
            The client must notify Vyomscode in writing via email or official communication.
          <br />
            A cancellation fee of 50% of the total agreed project cost is applicable.
          <br />
            This amount must be cleared within 7 days of cancellation notice, to compensate for the work already completed and services rendered.
          <br />
            Any delay in payment may result in legal action or penalty as per the terms agreed.
          <br />
          <br /> <h5 className="mb-0"> 4. Force Majeure or Disputes</h5>
          
            Vyomscode is not liable for cancellations or refund requests due to delays caused by:
          <br />
            Client inaction (e.g., delays in providing content or approvals)
          <br />
            Natural calamities, pandemics, or unforeseen legal restrictions
          <br />
            Changes in project scope or client-side decisions
          <br />
          <br /> <h5 className="mb-0"> 5. Final Note</h5> 
            By making the advance payment and confirming a project, the client agrees to abide by this Cancellation & Refund Policy. This ensures transparency and protects both parties’ interests during the course of the service.
          <br />
            If you have any concerns regarding this policy, feel free to contact us at:
          <br />
            📧 support@vyomscode.com
                      <br />
            📞 +91 8726324687
          <br />  
        </p> 
      </div>
    </section>
  );
}

export default CancellationandRefund;